<script>
import bem from '@/utils/bem';
import getPriceWithOrWithoutSale from '@/utils/getPriceWithOrWithoutSale';
import BeforeAfterPrice from '@/components/ux/beforAfterPrice/Before-after-price.vue';
import ChangeWizardCard from '@/components/modals/Change-wizard-card.vue';
import { mapActions } from 'vuex';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { BULLETS } from './constants';

const b = bem('second-card-design');

export default {
  data() {
    return {
      price: 0,
      additionalDiscount: 0,
      BULLETS,
      show: false,
    };
  },
  props: [
    'productName',
    'section',
    'index',
    'onLoadedData',
    'isStartPlay',
    'helpCenterList',
    'products',
    'designVersion',
    'cardsOrderUpdate',
    'lastIndex',
  ],
  methods: {
    ...mapActions({
      deleteWizardCardAction: 'wizards/deleteWizardCard',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    startPlay() {
      this.$refs.videoRef.play();
    },
    modalToggle(value) {
      this.show = value;
    },
    onDelete() {
      this.deleteWizardCardAction({ id: this.section.id, type: this.productName });
    },
  },
  components: {
    LeftOutlined,
    RightOutlined,
    ChangeWizardCard,
    BeforeAfterPrice,
  },
  mounted() {
    const {
      sales = [],
      quantity = 0,
      description,
      product,
    } = this.section;
    const feetCount = description.substring(0, description.indexOf(' '));
    const {
      price,
      additionalDiscount,
    } = getPriceWithOrWithoutSale({
      sales,
      quantity: quantity / feetCount,
      product,
    });
    this.price = Number(price);
    this.additionalDiscount = Number(additionalDiscount);
    if (this.isStartPlay) {
      this.startPlay();
    }
  },
  watch: {
    isStartPlay(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.startPlay();
      }
    },
  },
};
</script>

<template>
  <div :class="b('')" :style="{order: section.order}">
    <div :class="b('edit-button')">
      <a-button
        type="primary"
        size="small"
        @click="modalToggle(true)"
      >
        Edit
      </a-button>
    </div>
    <div :class="b('delete-button')">
      <a-popconfirm title="Sure to delete?" @confirm="onDelete">
        <a-button type="primary" size="small" html-type="button" danger>
          Delete
        </a-button>
      </a-popconfirm>
    </div>
    <ChangeWizardCard
      :section="section"
      title="Wizard card"
      :is-new-card="false"
      :products="products"
      :help-center-list="helpCenterList"
      v-model:show="show"
      :product-name="productName"
      :with-toggle="designVersion === 1"
    />
    <div
        :class="b('wrap', {
          marginLeft: this.section.product.dependQuantityProductIds
           && this.section.product.dependQuantityProductIds.length,
        })"
      >
      <div>
        <div :class="b('middle-block') ">
          <video
              :key='`digitize-video-banner-${index}`'
              :id='`digitize-video-banner-${index}`'
              :class="b('middle-block-video')"
              v-if="section.showFirst === 'video' && section.videoUrl"
              :src="section.videoUrl"
              ref="videoRef"
              :loop="true"
              :muted="true"
              @canplaythrough="onLoadedData(index)"
          />
          <img
              :class="b('middle-block')"
              :src="section.images[0]"
              alt=""
              v-else
          />
        </div>
        <div :class="b('top-block')">
          <div :class="b('top-block-title')">{{section.title}}</div>
          <div :class="b('top-block-description')">{{section.description}}</div>
          <div :class="b('top-block-description')">{{section.innerDescription}}</div>
        </div>
        <div :class="b('bullets-wrap')" v-for="bullet in BULLETS[index]" :key="bullet.id">
          <div :class="b('bullet')">
            <img
                :class="b('bullet-icon')"
                src="@/assets/images/yes-check.svg"
                alt='question'
                v-if="bullet.isCheckIcon"
            />
          <img
              :class="b('bullet-icon')"
              src="@/assets/images/no-x.svg"
              alt='question'
              v-else
            />
          <div :class="b('bullet-text')">{{bullet[productName]}}</div>
          </div>
        </div>
      </div>
      <div
          :class="b('bottom-block', {
            withPrice: Boolean(section.product && section.product.price ? section.product.price : 0)
          })"
      >
        <div v-if="price === 0">INCLUDED</div>
        <BeforeAfterPrice
            :textBeforeClassName="b('bottom-block-text')"
            :textAfterClassName="b('bottom-block-text')"
            :priceClassName="b('price-text')"
            :priceAfterClassName="b('text-price-after')"
            :price="price"
            :additionalDiscount="additionalDiscount"
            :withoutPrice="Boolean(price === 0)"
            textBefore="+"
            :textAfter="section.subTitle"
            :isRow="true"
            v-else
        />
      </div>
    </div>
    <div :class="b('order-buttons')">
      <div :class="b('button', { right: true })" v-if="index > 0">
        <a-button
          type="primary"
          size="small"
          @click="cardsOrderUpdate(index, index - 1)"
        >
          <template #icon>
            <LeftOutlined />
          </template>
        </a-button>
      </div>
      <div
        :class="b('button', { left: true })"
        v-if="index !== lastIndex"
      >
        <a-button
          type="primary"
          size="small"
          @click="cardsOrderUpdate(index, index + 1)"
        >
          <template #icon>
            <RightOutlined />
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./secondCardDesign.scss"></style>
